// https://github.com/w3c/IntersectionObserver/issues/295

let noop = () => {};
let OcclusionDetection = class {
    constructor ({
                     rootElement=document.body,
                     detectionElement='*', // TODO DOMs check
                     xGridCnt=10,
                     yGridCnt=10,
                 }) {
        this.detectionElement = detectionElement;
        this.rootElement = this.getDOM(rootElement);
        this.rootRect = this.getRect(this.rootElement);
        this.xGridCnt = xGridCnt; // 水平栅格份数
        this.yGridCnt = yGridCnt; // 垂直栅格份数
        this.xGridWidth = this.rootRect.width / xGridCnt; // 每个栅格宽度
        this.yGridHeight = this.rootRect.height / yGridCnt; // 每个栅格高度
        this.gridSizeMap = {}; // 存储每个栅格的信息
        this.gridPointsMap = {}; // 存储每个栅格的点 每次divideGrid会被初始化

        this.detectionElements = [...this.rootElement.querySelectorAll(detectionElement)]; // 需要检测的元素 记得动态更新
        this.detectionRectList = []; // 被遮挡元素的信息

        this._tick = noop;
        return this;
    }

    detect () {
        let start_time = performance.now();
        let s_time = start_time;
        let e_time = start_time;
        // console.log('start_time', start_time);

        this.divideGrid(); // 划分栅格
        // e_time = performance.now();
        // console.log('divideGrid', e_time - s_time);

        this.detectionElements = [...this.rootElement.querySelectorAll(this.detectionElement)]; // 需要检测的元素 记得动态更新

        // s_time  = performance.now();
        this.makeDetectionRect(); // 生成需要进行遮挡检测的元素信息 大量DOM获取操作 getBoundingClientRect
        // e_time = performance.now();
        // console.log('makeDetectionRect', e_time - s_time);

        // s_time  = performance.now();
        this.findDetection(); // 进行遮挡检测
        // e_time = performance.now();
        // console.log('findDetection', e_time - s_time);

        // window.a = this.detectionRectList;
        // window.ff = (list) => {
        //     let x = this.detectionRectList.filter(_ => {
        //         let flag = false;
        //         list.forEach(t => {
        //             if (_.element.innerHTML.includes(t)) {
        //                 flag = true;
        //             }
        //         });
        //         return flag;
        //     });
        //     console.log(x);
        // };
        // console.log('end-耗时', performance.now() - start_time, '\n\n\n');
        return this;
    }

    // 生成需要进行遮挡检测的元素信息
    makeDetectionRect () {
        this.detectionRectList = this.detectionElements.map((element, index) => {
            let rect = this.getRect(element);
            Object.assign(rect, {
                text: element.innerHTML,
                element, index,
                gridList: [], // 该元素属于那些栅格
            });
            this.fillGrid(rect);
            return rect;
        });
    }

    // 将各个元素填充到每个栅格中
    fillGrid (rect) {
        if (rect.text === '青花椒砂锅鱼（龙之梦购物中心虹口店）') {
            // debugger
        }

        // 异常点修整(比如超出画布范围的点)
        let correctNum  = (num, type) => {
            (num < 0) ? (num = 0) : null;
            (type === 'x' && num > this.xGridCnt-1) ? (num = this.xGridCnt-1) : null;
            (type === 'y' && num > this.yGridCnt-1) ? (num = this.yGridCnt-1) : null;
            return num;
        };

        // 计算矩形跨越了多少个小格子
        let leftGridNum = parseInt('' + (rect.left - this.rootRect.left) / this.xGridWidth );
        leftGridNum = correctNum(leftGridNum, 'x');
        let rightGridNum = parseInt('' + (rect.right - this.rootRect.left) / this.xGridWidth );
        rightGridNum = correctNum(rightGridNum, 'x');

        let topGridNum = parseInt('' + (rect.top - this.rootRect.top) / this.yGridHeight );
        topGridNum = correctNum(topGridNum, 'y');
        let bottomGridNum = parseInt('' + (rect.bottom - this.rootRect.top) / this.yGridHeight );
        bottomGridNum = correctNum(bottomGridNum, 'y');

        for (let i = leftGridNum; i <= rightGridNum; i++) {
            for (let j = topGridNum; j <= bottomGridNum; j++) {
                let gridKey = i + '-' + j;
                this.gridPointsMap[gridKey].push(rect); // 将元素记录到栅格
                rect.gridList.push(gridKey); // 将栅格信息记录到元素上
            }
        }
    }

    // 进行遮挡检测
    findDetection () {
        let isObscuredList = [];
        this.detectionRectList.forEach((curRect) => {
            let nearbyList = []; // 当前元素附近的元素
            curRect.gridList.map(gridKey => nearbyList = nearbyList.concat(this.gridPointsMap[gridKey])); // 获得当前元素附近的元素
            nearbyList = nearbyList.filter(_ => _ !== curRect); // 过滤掉自己 TODO 去重其他元素
            let isObscured = false;
            // nearbyList = this.detectionRectList; // 改成全量测试使用
            nearbyList.forEach(_ => {
                if (isObscured) {return void 0;}
                // 判断是否存在遮挡
                // console.log(curRect.element.innerHTML, _.element.innerHTML, curRect, _);
                if (!(curRect.left > _.right || curRect.right < _.left || curRect.top > _.bottom || curRect.bottom < _.top)) {
                    // 进行层级判断
                    if (curRect.index < _.index) {
                        isObscured = true;
                    }
                }
            });
            if (isObscured === true) {
                isObscuredList.push(curRect);
            }
        });
        this._tick(isObscuredList, this.detectionRectList);
    }

    // 划分栅格
    divideGrid () {
        for (let i = 0; i < this.xGridCnt; i++) {
            for (let j = 0; j < this.yGridCnt; j++) {
                let gridKey = i + '-' + j;
                this.gridSizeMap[gridKey] = {
                    width: this.xGridWidth,
                    height: this.yGridHeight,
                    x: this.rootRect.x + this.xGridWidth * i,
                    y: this.rootRect.y + this.yGridHeight * j,
                };
                this.gridPointsMap[gridKey] = [];
            }
        }
    }

    // tick 方法
    tick(cb=noop) {
        this._tick = cb;
        return this;
    }

    getRect (dom) {
        let rect = dom.getBoundingClientRect();
        return {
            DOMRect: rect, // 原生rect对象
            width: rect.width,
            height: rect.height,
            left: rect.left, // 左
            right: rect.right, // 右
            top: rect.top, // 上
            bottom: rect.bottom, // 下
            tl: {x: rect.left, y: rect.top}, // 上左
            tr: {x: rect.right, y: rect.top}, // 上右
            bl: {x: rect.left, y: rect.bottom}, // 下左
            br: {x: rect.right, y: rect.bottom}, // 下右
        }
    }

    getDOM(dom) {
        return typeof dom === 'string' ? document.querySelector(dom) : dom;
    }
};
export default OcclusionDetection;
// window.OcclusionDetection = OcclusionDetection;
